import { Component } from "@angular/core";
import {
  NgbCarouselConfig,
  NgbCarouselModule,
} from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-slider-events-call-to-action",
    imports: [NgbCarouselModule, TranslateModule],
    providers: [NgbCarouselConfig],
    templateUrl: "./slider-events-call-to-action.component.html",
    styleUrl: "./slider-events-call-to-action.component.scss"
})
export class SliderEventsCallToActionComponent {
  events = {
    data: [
      {
        title: "QUEREMOS FESTIVAL 2024",
        image: "./../../../assets/images/home/verao.jpg",
        date: "01/01/2000",
        hour: "22:30h",
        url: "#",
        location:"São Paulo - SP"
      },
      {
        title: "BUTEKO DO GUSTAVO LIMA 2O22",
        image: "./../../../assets/images/home/queremos-festival.jpg",
        date: "03/03/2020",
        hour: "02:30h",
        url: "#",
        location:"São Paulo - SP"
      },
      {
        title: "SHOW ZÉ HENRIQUE & JULIANO",
        image: "./../../../assets/images/home/viola.jpg",
        date: "11/11/2011",
        hour: "20:45h",
        url: "#",
        location:"São Paulo - SP"
      },
      {
        title: "SHOW DJ ALOK",
        image: "./../../../assets/images/home/banner_home_3.jpg",
        date: "21/09/2023",
        hour: "21:00h",
        url: "#",
        location:"São Paulo - SP"
      },
    ],
  };

  constructor(config: NgbCarouselConfig) {
    // customize default values of carousels used by this component tree
    config.interval = 4000;
    config.wrap = false;
    config.keyboard = true;
    config.showNavigationIndicators = true;
    config.showNavigationArrows = true;
    config.pauseOnFocus = false;
    config.pauseOnHover = true;
    config.animation = true;
  }
}
